import { create } from "zustand";

/**
 * UI state for the Tools panel (measure, fly-to, future additions).
 *
 *   open         — panel visibility (toggled from TopNav)
 *   activeTab    — which tool is currently shown ("measure" | "flyto" | ...)
 *   measureMode  — active measurement sub-mode ("distance" | "area" | null).
 *                  Mirrored from useMeasure() so MapView's cursor/click
 *                  handlers can read it via getState() without re-binding.
 *
 * Naming convention for future tools: keep tool-specific state under a
 * tool-prefixed key (measureMode, not just `mode`). Avoids collisions when
 * the next tool has its own modal state.
 */
export const useToolsUiStore = create((set, get) => ({
  open: false,
  activeTab: "measure",
  measureMode: null,

  // panel
  toggle: () => set({ open: !get().open }),
  openPanel: () => set({ open: true }),
  closePanel: () => set({ open: false }),

  // tabs
  setActiveTab: (tab) => set({ activeTab: tab }),

  // measure
  setMeasureMode: (mode) => set({ measureMode: mode }),
}));